(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.factory('AppointmentAdditionalInfo', [AppointmentAdditionalInfoFn]);

    /* additional info field object */
    function AppointmentAdditionalInfoFn() {
        var AppointmentAdditionalInfo = function () {

            // define default values
            this.caption = null;
            this.content = null;

            // vm id
            this.vmId = null;

            // export
            this.extend = extend;
            this.init = init;
            this.prepareForSave = prepareForSave;

            // extend
            function extend(object) {
                var self = this;
                angular.extend(self, object);
                // id
                self.vmId = Math.random();
            } // extend

            // init
            function init(type) {
                var self = this;
                if (typeof type === 'undefined' || type === null) { return; }

                self.caption = type.caption;
                self.isRequired = type.isRequired;
                self.vmId = Math.random();
            } // init

            // prepare
            function prepareForSave() {
                var self = this;
                delete self.vmId;
            }

        };

        return AppointmentAdditionalInfo;

        

    }
})();